export default __webpack_public_path__ + "static/media/06AW1JUL66.8df490f0.jpg";